// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__2PnQZ","itemA":"Write_itemA__LmdE7","itemB":"Write_itemB__1uZDB","itemC":"Write_itemC__3qSVZ","itemD":"Write_itemD__3UHBB"};